import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { deepCopy } from '../../../../../common/services/common.service';
import PageLoader from '../../../../../components/PageLoader';
import Popup from '../../../../../common/components/popup';
import ModalOneProgramComponent from '../components/one-program-modal.component';
import ProgramComponent from '../components/program.component';
import { mentors } from '../../../../../redux/mentors/action';
import { selectMentorsListItems, selectMentorsQueryItems } from '../../../../../redux/mentors/selector';
import { programHubs } from '../../../../../redux/program-hubs/action';
import { selectProgramHubsQueryItems } from '../../../../../redux/program-hubs/selector';


const AgencyProgram = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const [columnDefs, setColumnDefs] = useState({});
    const [selectOnePrograms, setSelectOnePrograms] = useState<any>([])
    const [addItem, setAddItem] = useState<any>(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const mentorsListis = useSelector(selectMentorsListItems)
    const queryItems = useSelector(selectProgramHubsQueryItems)
    const [selectedProgramValues, setSelectedProgramValues] = useState([]);
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [
        selectedPrograms,
        setSelectedPrograms
    ] = useState<any>([])

    const [
        mediaFiles,
        setMediaFiles
    ] = useState<any>([])


    const fetchQueryById = () => {
        dispatch(programHubs.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs/query`, entity: 'programHubs', jsonData: {
                Context: {},
                Records: [
                    {
                        "Id": parmas?.id
                    }
                ]

            }
        })).then(() => {
            setIsQuery(true)
        }).then(() => {
            setIsLoading(false)
        })




    }

    const handleInnerbasicFormChange: any = (event: any, field: string) => {
        setSelectedPrograms({ ...selectedPrograms, [field]: event })
        setSelectOnePrograms({ ...setSelectOnePrograms, [field]: event })
    }

    // media handle form change
    const handleFormMediaItemChange: any = ({ value }: any) => {
        setMediaFiles(value);
    }

    useEffect(
        () => {
            createColumnDefs()
            dispatch(mentors.list({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/one/mentors/list`,
                entity: 'mentors',
                jsonData: {}
            }))

                .then(() => {
                    if (parmas?.id > 0) {
                        fetchQueryById()

                    } else {
                        setIsLoading(false)
                    }
                })
        },
        []
    )
    useEffect(
        () => {

            if (isQuery) {
                const querydata: any = queryItems?.result?.items
                setSelectedPrograms(querydata)

                const oneProgramItemsData: any = queryItems?.result?.items?.ONEPrograms?.map((item: any) => {
                    const itemData = {
                        Id: item?.Id,
                        Name: item?.Name,
                        Description: item?.Description,
                        ProgramDuration: item?.ProgramDuration,
                        MentorIds: item?.MentorIds,
                        Price: item?.Price,
                        IncludesActivities: item?.IncludesActivities,
                        Activities: item?.Activities ||  [],
                        Specifications: item?.Specifications || [],
                        IsEnabled: item?.IsEnabled || false,
                 StartDateUtc: item?.StartDateUtc,
                 EndDateUtc: item?.EndDateUtc,


                    }
                    return itemData
                })
                console.log(oneProgramItemsData, 'oneProgramItemsData')
                setSelectedProgramValues(oneProgramItemsData)

            }
        },
        [isQuery]
    )



    const back = () => {
        navigate('/agencies/programshub/programs')
    }



    //Save the modal data function
    const handleSaveItem = async (data: any) => {

        // Collect new form data

        const newItem = {
            Id: data?.Id || Date.now(),
            Name: data?.Name,
           Description: data?.Description,
            ProgramDuration: data?.ProgramDuration,
            MentorIds: data?.MentorIds,
            Price: data?.Price,
            IncludesActivities: data?.IncludesActivities,
            Activities: data.Activities,
            Specifications: data?.Specifications,
            IsEnabled: data?.IsEnabled || false,
                 StartDateUtc: data?.StartDateUtc,
                 EndDateUtc: data?.EndDateUtc,
        }

        //Update the new data
        setSelectedProgramValues((prevState: any) => {
            // Check if the item exists by ID
            const exists = prevState.some((item: any) => item.Id === newItem.Id);
            // If it exists, update it, otherwise add the new item
            return exists
                ? prevState.map((item: any) => item.Id === newItem.Id ? newItem : item)
                : [...prevState, newItem];
        });
        closeModal();
    }

    // Add button
    const additionButtons: any = [
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
                    <title>Add One Program</title>
                    <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
                </svg>,
            callback: () => handleAddItem(),
        }
    ];

    //Table ColumnDef Function
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name' },
            { field: 'ProgramDuration', headerName: 'Program Duration' },
            { field: 'Price', headerName: 'Price', },


        ]);
    }

    //Add the data in the Table Function
    const handleAddItem = () => {
        setAddItem({
            id: 0
        });
    }

    //Table Edit Function
    const handleEdit = (itemData: any) => {
        setAddItem({
            id: itemData.id
        })
        setSelectOnePrograms(itemData)

    }

    //Table Delete Function
    const handleDelete = (data: any) => {
        setSelectedProgramValues((prevState: any) =>
            prevState.filter((item: any) => item?.Id !== data?.Id)
        );

    };

    //Modal Close Function
    const closeModal = () => {
        setAddItem(undefined)
        setSelectOnePrograms('')
    }

    // Modal Function
    const NewItemPopup = ({ handleSaveItem }: any) => {
        const [localItems, setLocalItems] = useState(deepCopy(selectOnePrograms));
        const handleLocalFormChange = (value: any, field: any) => {
            setLocalItems((prev: any) => ({
                ...prev,
                [field]: value,
            }));
        };
        const handleItemSubmit = () => {
            setLocalItems(localItems);
            handleSaveItem(localItems)
        };
        return (
            <>
                <Popup onClose={closeModal}>
                    <ModalOneProgramComponent
                        Close={closeModal}
                        mentors={mentorsListis?.result?.items}
                        handleItemSubmit={handleItemSubmit}
                        selectOnePrograms={localItems}
                        onInnerBasicFormChange={handleLocalFormChange}

                    />

                </Popup>
            </>
        )
    }

    // Submit the program Function
    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
            mediaFiles.length - 1,
            1
        )
        const oneProgramItemsData: any = selectedProgramValues.map((item: any) => {
            const itemData = {
                Id:item?.Id || 0,
                Name: item?.Name,
                Description:item?.Description,
                ProgramDuration: item?.ProgramDuration,
                MentorIds: item?.MentorIds || [],
                Price: item?.Price,
                IncludesActivities: item?.IncludesActivities,
                Activities:item?.Activities || [],
                Specifications: item?.Specifications || [],
                 IsEnabled: item?.IsEnabled || false,
                 StartDateUtc: item?.StartDateUtc,
                 EndDateUtc: item?.EndDateUtc,

            }
            return itemData
        })
        const programData = {


            "Id": selectedPrograms?.Id || 0,
            "IsActive": selectedPrograms?.IsActive,
             "IsEnabled": selectedPrograms?.IsEnabled,
            "Name": selectedPrograms?.Name,
            "Description": selectedPrograms?.Description,
            "StartDateUtc": selectedPrograms?.StartDateUtc,
            "EndDateUtc": selectedPrograms?.EndDateUtc,
            "ONEPrograms": oneProgramItemsData,
            "MediaMappings": {
                "MediaFiles": mediaFiles,
                "Templates": []

            }
        }
        if (parmas?.id > 0) {
            await dispatch(programHubs.resetAction({ actionType: 'update' }))
            await dispatch(programHubs.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs`, entity: 'programHubs', jsonData: {
                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        } else {
            await dispatch(programHubs.resetAction({ actionType: 'create' }))
            await dispatch(programHubs.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/one-programs`, entity: 'programHubs', jsonData: {

                    Context: {},
                    Records: [
                        programData
                    ]

                }
            })).then(() => {
                back()
            })

        }

    }

    return (
        <>

            {
                addItem ? <NewItemPopup handleSaveItem={handleSaveItem} /> : <></>
            }
            {isLoading ? <PageLoader /> :


                <ProgramComponent
                    onInnerBasicFormChange={handleInnerbasicFormChange}
                    selectedPrograms={selectedPrograms}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    onFormItemChange={handleFormMediaItemChange}
                    id={parmas?.id}
                    selectedProgramValues={selectedProgramValues}
                    columnDefs={columnDefs}
                    handleEdit={handleEdit}
                    additionButtons={additionButtons}
                    handleDelete={handleDelete}
                />
            }

        </>
    )

}

export default AgencyProgram;